import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { language, switchLanguage, t } = useLanguage();

  return (
    <div className="language-switcher">
      <label className="language-label">{t.language}:</label>
      <div className="language-buttons">
        <button
          className={`lang-btn ${language === 'en' ? 'active' : ''}`}
          onClick={() => switchLanguage('en')}
        >
          {t.english}
        </button>
        <button
          className={`lang-btn ${language === 'zh' ? 'active' : ''}`}
          onClick={() => switchLanguage('zh')}
        >
          {t.chinese}
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
